/**
 * Image with text section
 * Plays video when in viewport, pauses when out of view
 */

(function() {
  'use strict';

  var initializedSections = new WeakSet();

  class ImageWithText {
    constructor(container) {
      this.container = container;
      this.wrapper = container.querySelector('.video_wrapper');
      this.video = container.querySelector('.image-with-text__video');
      this.autoplay = container.dataset.videoAutoplay !== 'false';
      this.observer = null;
      this.init();
    }

    init() {
      if (!this.video) return;

      this.setupHoverControls();

      if (this.autoplay) {
        this.video.muted = true;
        this.setupAutoplay();
      } else {
        this.video.muted = false;
        this.setupPlayOverlay();
      }
    }

    setupPlayOverlay() {
      this.playButton = this.wrapper.querySelector('.image-with-text__play-button');
      if (!this.playButton) return;

      this.playButton.addEventListener('click', () => {
        this.playVideo();
      });

      this.video.addEventListener('play', () => {
        this.wrapper.classList.add('is-playing');
      });

      this.video.addEventListener('pause', () => {
        this.wrapper.classList.remove('is-playing');
      });
    }

    setupAutoplay() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.playVideo();
            } else {
              this.video.pause();
            }
          });
        },
        { threshold: 0.1 }
      );

      this.observer.observe(this.video);

      if (this.isInViewport(this.video)) {
        this.playVideo();
      }

      if (this.video.readyState < 2) {
        this.video.addEventListener('loadeddata', () => {
          if (this.isInViewport(this.video)) {
            this.playVideo();
          }
        }, { once: true });
      }
    }

    isInViewport(element) {
      var rect = element.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      return rect.bottom > 0 && rect.top < viewportHeight && rect.width > 0;
    }

    playVideo() {
      var playPromise = this.video.play();

      if (playPromise !== undefined) {
        playPromise.catch(function() {});
      }
    }

    setupHoverControls() {
      if (!this.wrapper) return;

      this.wrapper.addEventListener('mouseenter', () => {
        this.video.controls = true;
      });

      this.wrapper.addEventListener('mouseleave', () => {
        this.video.controls = false;
      });
    }

    onUnload() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.video) {
        this.video.pause();
      }
    }
  }

  function initSection(section) {
    if (!section || section.getAttribute('data-section-type') !== 'image-with-text') return;
    if (initializedSections.has(section)) return;

    initializedSections.add(section);
    new ImageWithText(section);
  }

  function initAllSections() {
    document.querySelectorAll('[data-section-type="image-with-text"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initSection(document.querySelector('[data-section-id="' + event.detail.sectionId + '"]'));
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
    if (section) {
      initializedSections.delete(section);
    }
  });
})();
